export class LocationApiLoader {
    constructor(callbacks) {        
        $.ajax({
            dataType: "script",
            cache: true,
            url: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyALpZboQbieD8FePSqE0JK2LdTvHlnAZy4&libraries=places&callback=Function.prototype',
            success: function () {
                for (const callback of callbacks) {
                    callback();
                }
            }
        });
    }
}